import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { TruncateLines } from 'react-truncate-lines';

/**
 * A component for displaying text with thematic typography styles.
 */ const Text = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Text', props, ref);
    const { align, as: Component = 'span', block = false, children, css, color = 'inherit', colorTone = 'medium', italic = false, lineHeight, size, strikethrough = false, truncate = false, verticalAlign, weight, ...elementProps } = mergedProps;
    const textCss = useCss(({ mixins })=>[
            block && {
                display: 'block'
            },
            mixins.typography({
                align,
                color,
                colorTone,
                italic,
                lineHeight,
                size,
                strikethrough,
                verticalAlign,
                weight
            }),
            (truncate === true || truncate === 1) && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-text": true,
        "data-size": size,
        ...elementProps,
        ref: mergedRef,
        css: [
            textCss,
            css
        ],
        children: typeof truncate === 'number' && truncate > 1 && typeof children === 'string' ? /*#__PURE__*/ jsx(TruncateLines, {
            lines: typeof truncate === 'number' ? truncate : 1,
            children: children
        }) : children
    });
});

export { Text };
//# sourceMappingURL=text.js.map
